import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../../src/Hidden/Hidden.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`The `}<inlineCode parentName="p">{`Hidden`}</inlineCode>{` component is a utility component that will help you hide or show content/components in different viewports.`}</p>
    <Note mdxType="Note">Use Hidden only to control behaviour in a responsive manner. It does not take any `sx` props.</Note>
    <h2>{`Examples`}</h2>
    <h3>{`Single viewport value provided`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Hidden when="narrow">
  <Placeholder height="80px" label="This is not visible in narrow viewport" />
</Hidden>
`}</code></pre>
    <h3>{`Multiple viewport values provided`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Hidden when={['narrow', 'wide']}>
  <Placeholder height="80px" label="This is not visible in narrow and wide viewport" />
</Hidden>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      